import React, { useEffect, useState } from "react";
import { makeStyles, Typography, Grid, Button, Box } from "@material-ui/core/";
import { useSelector, useDispatch } from "react-redux";
import {
  getprofileData,
  postprofileData,
} from "../../../../reduxSlices/profileSlice";
import localizedStrings from "../../../../utils/localize";
import SnackBar from "../../../SnackBar";
import AllFormData from "../profileForms/formData";
const useStyle = makeStyles((theme) => ({
  container: {
    padding: "1rem 0",
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginBottom: "-9px !important",
  },
  profileFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
}));

const TopItems = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const [FormData, setFormData] = useState(AllFormData);
  const [primaryDetails, setPrimaryDetails] = useState(FormData.primaryDetails);
  const profileDataEdit = useSelector(
    (state) => state.profileData.profileDataEdit,
  );
  const [displayMessage, setDisplayMessage] = useState("");
  const [disabledValue, setDisabledValue] = useState(true);
  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });

  useEffect(() => {
    const countryId = profileDataEdit?._ses_countryofresidence_value;
    const isUSorCanada =
      countryId === "01f93658-1116-ee11-9cbe-000d3af4f17d" ||
      countryId === "c3f83658-1116-ee11-9cbe-000d3af4f17d";
    const hasValue = (value) =>
      value !== null && value !== undefined && value !== "";

    if (
      !hasValue(profileDataEdit.ses_emergencycontactname) ||
      !hasValue(profileDataEdit.ses_emergencycontactrelationship) ||
      !hasValue(profileDataEdit.ses_emergencycontactphone) ||
      !hasValue(profileDataEdit.telephone1) ||
      !hasValue(countryId) ||
      !hasValue(profileDataEdit.address1_line1) ||
      !hasValue(profileDataEdit.address1_city) ||
      (isUSorCanada &&
        (!hasValue(profileDataEdit.ses_stateorprovince) ||
          !hasValue(profileDataEdit.address1_postalcode)))
    ) {
      setDisabledValue(true);
    } else {
      setDisabledValue(false);
    }
  }, [profileDataEdit]);

  {
    /*Use the algorithm to determine if the SIN is valid.
There are 9 digits in the SIN.
Each one is multiplied by a specific number.
The sum of these 9 products is divided by 10.
If the result is a whole number, the SIN is valid. If not, it is invalid.

Here are the numbers that need to be used for the multiplication.

first digit x 1
second digit x 2
third digit x 1
fourth digit x 2
fifth digit x 1
six digit x 2 
seventh digit x 1
eighth digit x 2
ninth digit x 1

If the multiplication produces a two-digit number, the two digits are added together to get a single digit.*/
  }

  function validateAndCheckSIN(sin) {
    if (sin === ("" || null)) return true; // Validation not needed.

    // Remove any non-digit characters from the input SIN
    const cleanedSIN = sin.replace(/\D/g, "");

    // Check if the cleaned SIN is not empty, has 9 digits, and the first digit is not 0 or 8
    if (/^\d{9}$/.test(cleanedSIN) && !["0", "8"].includes(cleanedSIN[0])) {
      // Define the multiplication factors
      const factors = [1, 2, 1, 2, 1, 2, 1, 2, 1];

      // Calculate the sum of products
      let sum = 0;
      for (let i = 0; i < 9; i++) {
        let product = parseInt(cleanedSIN[i]) * factors[i];

        // If the product is a two-digit number, add its digits together
        if (product >= 10) {
          product = Math.floor(product / 10) + (product % 10);
        }

        sum += product;
      }

      // Check if the result is divisible by 10
      return sum % 10 === 0;
    } else {
      return false;
    }
  }

  const handleSave = async () => {
    var validationResult = validateAndCheckSIN(profileDataEdit.governmentid);

    const newPrimaryDetails = { ...primaryDetails };

    if (
      !validationResult &&
      !newPrimaryDetails.governmentid.elementConfig.disabled
    ) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = localizedStrings.general.profileSINErrorMsg;
      setShowSnackBar(status);
      return;
    } else if (
      validationResult ||
      newPrimaryDetails.governmentid.elementConfig.disabled
    ) {
      let updatedProfileData = { ...profileDataEdit };
      if (
        profileDataEdit.governmentid != null &&
        profileDataEdit.governmentid != ""
      ) {
        // Create a new object with the modified governmentid property
        updatedProfileData = {
          ...profileDataEdit,
          governmentID: profileDataEdit?.governmentid,
          governmentid: profileDataEdit?.governmentid?.replace(/\D/g, ""),
        };
      }

      const response = await dispatch(
        postprofileData({
          ...updatedProfileData,
          contactid: window.localStorage.getItem("x-auth-contactId"),
        }),
      );

      if (response) {
        window.location.reload();
      }
    }
  };

  const handleClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
  };
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  return (
    <>
      <Grid className={classes.container} style={{ marginBotton: "-9px" }}>
        <SnackBar
          open={showSnackBar.status}
          message={showSnackBar.message}
          handleClose={handleClose}
        />
        <Typography component="div" className={classes.profileFont}>
          {localizedStrings.students.profile.heading}
        </Typography>

        <Typography component="div">
          <Button
            variant="contained"
            color="primary"
            disabled={disabledValue}
            onClick={handleSave}
          >
            {localizedStrings.students.profile.save}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            style={{ marginLeft: "0.5rem" }}
            onClick={() =>
              dispatch(
                getprofileData(window.localStorage.getItem("x-auth-contactId")),
              )
            }
          >
            {localizedStrings.students.profile.refresh}
          </Button>
        </Typography>
      </Grid>
      <Typography style={{ marginBottom: "21px" }}>
        {" "}
        {localizedStrings.students.profile.info}
      </Typography>
    </>
  );
};

export default TopItems;
